import React, { useState } from 'react';
import GenericQR from './GenericQR';
import CnicQR from './CnicQR';
import './QRGenerator.css';

function QRGenerator() {
  const [activeTab, setActiveTab] = useState('generic');

  return (
    <div className="qr-generator-container">
      <div className="tab-buttons">
        <button
          className={`tab-button ${activeTab === 'generic' ? 'active' : ''}`}
          onClick={() => setActiveTab('generic')}
        >
          Generic QR Code
        </button>
        <button
          className={`tab-button ${activeTab === 'cnic' ? 'active' : ''}`}
          onClick={() => setActiveTab('cnic')}
        >
          Course Feedback Form QR Code
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'generic' ? <GenericQR /> : <CnicQR />}
      </div>
    </div>
  );
}

export default QRGenerator;